import React from "react";

export default function ConfidentialityCSP(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Confidentiality
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Every effort should be made to ensure that confidentiality is
            maintained while disseminating information. This includes the
            following:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                the parents of the child who is alleged to have been abused
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                the person making the allegation
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Child Welfare Committee /Police
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            All incidents, allegations and complaints shall be recorded and related documents 
shall be stored securely by CPO with access being restricted to the designated 
persons. The documents/ records should, inter-alia, contain the following:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The child's name, age and date of birth of the child.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The child's home address and telephone number. 
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Whether or not the person making the report is expressing their own concerns 
or those of someone else.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The nature of the allegation. Include dates, times, any special factors and other relevant information. 
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Make a clear distinction between what is fact, opinion or hearsay. 
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Details of witnesses to the incidents. 
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Have the parents been contacted? If so what has been said?
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Has the child been spoken to? If so what was said?
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Details of person alleged to be the abuser. 
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
